import type { PetLossLocale } from '@paction-2.0/util/petLossReadiness';
import { PACTION_PUBLIC_ORIGIN } from '@paction-2.0/util/url';

export const PET_LOSS_READINESS_PATHS: Record<PetLossLocale, string> = {
  en: '/pet-loss-readiness',
  fr: '/pet-loss-readiness/fr'
};

export const petLossReadinessLanguageAlternates = () => ({
  'en-CA': `${PACTION_PUBLIC_ORIGIN}${PET_LOSS_READINESS_PATHS.en}`,
  'fr-CA': `${PACTION_PUBLIC_ORIGIN}${PET_LOSS_READINESS_PATHS.fr}`,
  'x-default': `${PACTION_PUBLIC_ORIGIN}${PET_LOSS_READINESS_PATHS.en}`
});
